angular.module('am4')
.factory('equipmentGroupService', function($http, apiUrl) {
    return {
        getEquipmentGroups: function(facility_id) {
            return $http.get(apiUrl + '/facilities/' + facility_id + '/group')
            .then(function(res) {
                return res.data;
            });
        },
        getEquipmentGroupByID: function(facility_id, group_id) {
            return $http.get(apiUrl + '/facilities/' + facility_id + '/group/' + group_id)
            .then(function(res) {
                return res.data;
            });
        },
        createEquipmentGroup: function(facility_id, name) {
            return $http.post(apiUrl + '/facilities/' + facility_id + '/group', {
                name: name
            })
            .then(function(res) {
                return res.data;
            });
        },
        deleteEquipmentGroup: function(facility_id, group_id) {
            return $http.delete(apiUrl + '/facilities/' + facility_id + '/group/' + group_id)
            .then(function(res) {
                return res.data;
            });
        },
        updateEquipmentGroup: function(facility_id, group_id, data) {
            return $http.put(apiUrl + '/facilities/' + facility_id + '/group/' + group_id, data)
            .then(function(res) {
                return res.data[0];
            });
        },
        getMachineEquipmentGroups: function(facility_id, frame_serial) {
            return $http({
                method: 'GET',
                url: apiUrl + '/machines/' + frame_serial + '/group',
                params: {
                    facility_id: facility_id
                }
            })
            .then(function(res) {
                return res.data;
            });
        },
        addMachineToEquipmentGroup: function(facility_id, frame_serial, group_id) {
            return $http({
                method: 'POST',
                url: apiUrl + '/machines/' + frame_serial + '/group/' + group_id,
                params: {
                    facility_id: facility_id
                }
            })
            .then(function(res) {
                return res.data;
            });
        },
        removeMachineFromEquipmentGroup: function(facility_id, frame_serial, group_id) {
            return $http({
                method: 'DELETE',
                url: apiUrl + '/machines/' + frame_serial + '/group/' + group_id,
                params: {
                    facility_id: facility_id
                }
            })
            .then(function(res) {
                return res.data;
            });
        },
        getNonconnectedMachineEquipmentGroups: function(facility_id, machine_id) {
            return $http({
                method: 'GET',
                url: apiUrl + '/nonconnected_machines/' + machine_id + '/group',
                params: {
                    facility_id: facility_id
                }
            })
            .then(function(res) {
                return res.data;
            });
        },
        addNonconnectedMachineToEquipmentGroup: function(facility_id, machine_id, group_id) {
            return $http({
                method: 'POST',
                url: apiUrl + '/nonconnected_machines/' + machine_id + '/group/' + group_id,
                params: {
                    facility_id: facility_id
                }
            })
            .then(function(res) {
                return res.data;
            });
        },
        removeNonconnectedMachineFromEquipmentGroup: function(facility_id, machine_id, group_id) {
            return $http({
                method: 'DELETE',
                url: apiUrl + '/nonconnected_machines/' + machine_id + '/group/' + group_id,
                params: {
                    facility_id: facility_id
                }
            })
            .then(function(res) {
                return res.data;
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/services/equipmentGroups.js